"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBApiDetailsContactUs", {
  enumerable: true,
  get: function get() {
    return _SVBApiDetailsContactUs.default;
  }
});
var _SVBApiDetailsContactUs = _interopRequireDefault(require("./src/SVBApiDetailsContactUs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }